import css from "styled-jsx/css";
import { rdcUiTheme } from "@rdc-npm/rdc-ui";
export default css`
  @import "src/static/styles/variables";
  @import "src/static/styles/mixins/mixins";

  .linkButton {
    background: none !important;
    border: none;
    padding: 0 !important;
    color: ${rdcUiTheme.color.interactive.primary.default.initial};
    font-weight: ${rdcUiTheme.typography.weight.medium};
    text-decoration-line: underline;
    cursor: pointer;
    font-size: 16px;
    &.review-rating {
      margin-bottom: 0px !important;
    }
  }
  .show-more-link {
    &.review-rating {
      margin-bottom: 0px !important;
    }
    margin-bottom: 0rem !important;
  }
  .fade-out {
    height: 30px;
    margin-top: -30px;
    margin-bottom: 12px;
    position: relative;
  }
  .fade-out:after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  }
`;
